<script type="text/jsx">
import { mapGetters } from 'vuex'
export default {
  name: 'WarrantyService',
  computed: {
    ...mapGetters({
      content: 'home/getContent'
    })
  },
  render () {
    return (
      <section class="warranty-service">
        <header class="warranty-service__header">
          {this.content.lang_strings && <h2 class="warranty-service__title title">
            { this.content.lang_strings.features_title }
          </h2>}
          {this.content.lang_strings && <h2 class="warranty-service__text text">
            { this.content.lang_strings.features_text.replace('%s', this.content.brands.length) }
          </h2>}
        </header>
        {this.content.features && <ul class="warranty-service__list">
          {this.content.features.map((feature, index) => {
            return <li class="warranty-service__item" key={feature.id}>
              <span class="warranty-service__count">0{index + 1}</span>
              <h3 class="warranty-service__item-title">{ feature.name }</h3>
              <p class="warranty-service__description">{ feature.description }</p>
            </li>
          })}
        </ul>}
      </section>
    )
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Other/WarrantyService.vue